import { Controller } from "@hotwired/stimulus";

// Revenue-by-Plan table on the MRR report. Each parent row represents
// a canonical plan; child rows (the shadow / custom-priced variants)
// are hidden by default and toggled in by clicking the parent OR by
// the page-level "Expand variants" button.
//
// Rows are paired via data-row-id so multiple parents can be expanded
// independently. The chevron rotates 90° when its row is open.
export default class extends Controller {
  static targets = ["child", "chevron", "toggleAll"];

  connect() {
    this._allOpen = false;
  }

  toggleRow(event) {
    const rowId = event.params.rowId?.toString();
    if (!rowId) return;
    const willOpen = this.childTargets.some(
      (el) => el.dataset.rowId === rowId && el.classList.contains("hidden")
    );
    this.setRow(rowId, willOpen);
    this.refreshToggleAllLabel();
  }

  toggleAll() {
    this._allOpen = !this._allOpen;
    const ids = new Set(this.childTargets.map((el) => el.dataset.rowId));
    ids.forEach((id) => this.setRow(id, this._allOpen));
    this.refreshToggleAllLabel();
  }

  setRow(rowId, open) {
    this.childTargets.forEach((el) => {
      if (el.dataset.rowId !== rowId) return;
      el.classList.toggle("hidden", !open);
    });
    this.chevronTargets.forEach((el) => {
      if (el.dataset.rowId !== rowId) return;
      el.style.transform = open ? "rotate(90deg)" : "";
    });
  }

  refreshToggleAllLabel() {
    if (!this.hasToggleAllTarget) return;
    const anyHidden = this.childTargets.some((el) => el.classList.contains("hidden"));
    this._allOpen = !anyHidden;
    this.toggleAllTarget.textContent = anyHidden ? "Expand variants" : "Collapse variants";
  }
}
